import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  note: {
    lineHeight: 1.5
  },
  actionButton: {
    ...reskinStyles(theme, {
      borderRadius: 22,
      color: theme.colorPalette.white,
      '&:hover': { backgroundColor: theme.colorPalette.green_90 },
      '& img': { filter: 'brightness(0) invert(1)' }
    })
  },
  button: {
    display: 'flex',
    fontSize: 12,
    gap: theme.spacing(2)
  },
  action: {
    fontSize: 12,
    ...reskinStyles(theme, { color: 'inherit' })
  }
});

export default makeStyles(styles);
